import { render, staticRenderFns } from "./hostGTest.vue?vue&type=template&id=35796ef8&scoped=true&"
import script from "./hostGTest.vue?vue&type=script&lang=js&"
export * from "./hostGTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35796ef8",
  null
  
)

export default component.exports